<template lang="pug">
	canvas(ref="canvas") Lo siento, pero tu navegador no soporta esta función
</template>

<script>
export default {
	data () {
		return {
			ancho: 0,
			alto: 0,
			x: 0,
			y: 0,
			mensaje: null,
			presion: 0
		}
	},
	mounted () {
		const canvas = this.$refs.canvas
		let isMousedown = false
		let context = canvas.getContext('2d')
		let lineWidth = 0
		let points = []
		let pressure = 0.1
		this.getDim()
		canvas.width = canvas.offsetWidth
		canvas.height = canvas.offsetHeight

		;['touchstart', 'mousedown'].forEach(ev => {
			canvas.addEventListener(ev, e => {
				var x, y
				if (e.touches && e.touches[0]) {
					if (e.touches[0].force && e.touches[0]['force'] > 0) {
						pressure = e.touches[0]['force']
					}
					const dim = this.getOffset(e.target)
					x = e.touches[0].pageX - dim.left
					y = e.touches[0].pageY - dim.top
				} else {
					this.mensaje = 'No touch'
					pressure = 0.2
					x = e.layerX
					y = e.layerY
				}
				isMousedown = true
				// lineWidth = (pressure * 50 * 0.8 + lineWidth * 0.2)
				context.lineWidth = lineWidth// pressure * 50;
				context.strokeStyle = 'black'
				context.lineCap = 'round'
				context.lineJoin = 'round'
				context.beginPath()
				context.moveTo(x, y)
				points.push({
					x, y, lineWidth
				})

				this.x = x
				this.y = y
			})
		})
		;['touchmove', 'mousemove'].forEach(ev => {
			canvas.addEventListener(ev, e => {
				if (!isMousedown) {
					this.mensaje = 'No hay pulsación'
					return
				}
				var x, y
				if (e.touches && e.touches[0] && typeof e.touches[0]['force'] !== 'undefined') {
					if (e.touches[0]['force'] > 0) {
						pressure = e.touches[0]['force']
					}
					const dim = this.getOffset(e.target)
					x = e.touches[0].pageX - dim.left
					y = e.touches[0].pageY - dim.top
				} else {
					pressure = 0.2
					x = e.layerX
					y = e.layerY
				}

				lineWidth = (Math.log(pressure + 1) * 15 * 0.4 + lineWidth * 0.6)
				points.push({
					x, y, lineWidth
				})
				context.strokeStyle = 'black'
				context.lineCap = 'round'
				context.lineJoin = 'round'
				// context.lineWidth   = lineWidth// pressure * 50;
				// context.lineTo(x, y);
				// context.moveTo(x, y);
				if (points.length >= 3) {
					var l = points.length - 1
					var xc = (points[l].x + points[l - 1].x) / 2
					var yc = (points[l].y + points[l - 1].y) / 2
					context.lineWidth = points[l - 1].lineWidth
					context.quadraticCurveTo(points[l - 1].x, points[l - 1].y, xc, yc)
					context.stroke()
					context.beginPath()
					context.moveTo(xc, yc)
				}

				this.presion = pressure
				// $force.innerHTML = 'force = ' + pressure
				// $touches.innerHTML = 'touchev = ' + (e.touches ? JSON.stringify(e.touches[0]) : '')
				e.preventDefault()
				this.x = x
				this.y = y
			})
		})
		;['touchend', 'touchleave', 'mouseup'].forEach(ev => {
			canvas.addEventListener(ev, e => {
				isMousedown = false
				context.strokeStyle = 'black'
				context.lineCap = 'round'
				context.lineJoin = 'round'
				if (points.length >= 3) {
					var l = points.length - 1
					context.quadraticCurveTo(points[l].x, points[l].y, this.x, this.y)
					context.stroke()
				}
				points = []
				lineWidth = 0
			})
		})
	},
	methods: {
		reset () {
			const canvas = this.$refs.canvas
			const context = canvas.getContext('2d')
			context.clearRect(0, 0, canvas.width, canvas.height)
		},
		getOffset (el) {
			const dim = {
				top: 0,
				left: 0
			}

			do {
				dim.top += el.offsetTop || 0
				dim.left += el.offsetLeft || 0
				el = el.offsetParent
			} while (el)
			return dim
		},
		getDim () {
			const canvas = this.$refs.canvas
			this.ancho = canvas.offsetWidth
			this.alto = canvas.offsetHeight
		},
		firmar () {
			const canvas = this.$refs.canvas
			const img = canvas.toDataURL('image/png')
			this.$emit('firma', img)
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>

<style scoped>
canvas {
	width: 350px;
	height: 150px;
	border: 1px solid #333333;
}
</style>



// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/components/visor-contrato/firmar.vue